import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "class-analysis-container" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "search-container" }
const _hoisted_4 = { class: "section" }
const _hoisted_5 = { class: "search-container" }
const _hoisted_6 = { style: {"font-size":"12px","color":"#888"} }
const _hoisted_7 = {
  key: 0,
  class: "summary-info"
}
const _hoisted_8 = { class: "summary-wrap" }
const _hoisted_9 = { class: "summary-item" }
const _hoisted_10 = { class: "summary-value" }
const _hoisted_11 = { class: "summary-item" }
const _hoisted_12 = { class: "summary-value" }
const _hoisted_13 = { class: "summary-item" }
const _hoisted_14 = { class: "summary-value" }
const _hoisted_15 = { class: "summary-item" }
const _hoisted_16 = { class: "summary-value" }
const _hoisted_17 = { class: "summary-item" }
const _hoisted_18 = { class: "summary-value" }
const _hoisted_19 = { class: "summary-item" }
const _hoisted_20 = { class: "summary-value" }
const _hoisted_21 = {
  key: 1,
  class: "empty-tip"
}

import { ref, watch, onMounted, computed } from 'vue';
import { postClassAlwaysTopBottomStudents } from '@/servers/api/average';
import { getStudentApi, postBatchGetStudentApi } from '@/servers/api/student';
import { message } from 'ant-design-vue';
import { getClassKnowledgePointMasteryApi, getClassKnowledgePointsApi } from '@/servers/api/analysis'
import { debounce } from 'lodash';


export default /*@__PURE__*/_defineComponent({
  __name: 'ClassAnalysis',
  props: {
    classId: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;
const loading = ref(false);
// 科目名称映射表（支持拼音键和中文键，统一转为中文显示）
const subjectMap: Record<string, string> = {
  // 拼音键 → 中文
  'yuwen': '语文',
  'shuxue': '数学',
  'yingyu': '英语',
  'wuli': '物理',
  'huaxue': '化学',
  'shengwu': '生物',
  'lishi': '历史',
  'zhengzhi': '政治',
  'dili': '地理',
  'sum_': '总分',
  // 中文键 → 中文（兼容已有数据）
  '语文': '语文',
  '数学': '数学',
  '英语': '英语',
  '物理': '物理',
  '化学': '化学',
  '生物': '生物',
  '历史': '历史',
  '政治': '政治',
  '地理': '地理',
  '总分': '总分'
};
// 学生过线率列表数据
const studentRateList = ref<any[]>([]);
// 学生 uid → 姓名 映射表（从学生列表接口获取，补充过线率数据中缺失的姓名字段）
const studentNameMap = ref<Map<string, string>>(new Map());
// 表格列定义（增加排序功能）
const studentRateColumns = ref<any[]>([
  { title: '学生姓名', dataIndex: 'name', width: 120, fixed: 'left', align: 'center' },
  { title: '学号', dataIndex: 'uid', width: 120, fixed: 'left', align: 'center', customRender: ({ text }: any) => maskStudentId(text) },
]);

// 获取班级学生列表，建立 uid → 姓名 映射
const fetchStudentNames = async (classId: number) => {
  if (!classId) return;
  try {
    const res = await getStudentApi({
      class_id: classId,
      page: 1,
      size: 999,
    });
    if (res.code === 200 && res.data) {
      const list = Array.isArray(res.data) ? res.data : (res.data.records || res.data.list || []);
      const map = new Map<string, string>();
      list.forEach((s: any) => {
        if (s.uid != null) {
          map.set(String(s.uid), s.name || '');
        }
      });
      studentNameMap.value = map;
    }
  } catch (err) {
    console.error('获取班级学生列表失败:', err);
  }
};
// 用批量接口补齐花名册中缺失的姓名（覆盖「历史考试有、当前花名册没有」的学生）
const fillMissingStudentNames = async (classData: any) => {
  const studentOneLineRate = classData?.student_one_line_rate || {};
  const missingUids = new Set<string>();
  Object.values(studentOneLineRate).forEach((students: any) => {
    if (!Array.isArray(students)) return;
    students.forEach((student: any) => {
      if (!student) return;
      const uid = student.uid == null ? '' : String(student.uid);
      if (!uid) return;
      // 过线率数据里没带姓名，且花名册映射里也查不到，才需要批量补
      if (!student.name && !studentNameMap.value.has(uid)) {
        missingUids.add(uid);
      }
    });
  });
  if (missingUids.size === 0) return;
  try {
    const res = await postBatchGetStudentApi({ student_ids: [...missingUids] });
    if (res?.code === 200 && res.data) {
      const list = Array.isArray(res.data) ? res.data : (res.data.records || res.data.list || []);
      list.forEach((s: any) => {
        if (s.uid != null) {
          studentNameMap.value.set(String(s.uid), s.name || '');
        }
      });
    } else {
      console.warn('批量获取学生姓名失败:', res?.msg || res?.message || res);
    }
  } catch (err) {
    console.error('批量补齐学生姓名失败:', err);
  }
};
// 搜索相关
const searchName = ref<string>('');
const selectedSubject = ref<string>('');
const rateRange = ref<string | undefined>(undefined);
const sortOrder = ref<string>('desc'); // 排序方式，默认降序
// 学生姓名选项（用于自动完成）
const studentNameOptions = computed(() => {
  return studentRateList.value.map(student => ({
    value: student.uid,
    label: student.name
  }));
});
// 可用的科目列表
const availableSubjects = ref<{ value: string; label: string }[]>([]);
// 过滤后的学生列表
const filteredStudentRateList = computed(() => {
  let result = studentRateList.value;
  // 按姓名或学号筛选
  if (searchName.value) {
    result = result.filter(student => {
      const nameMatch = student.name.toLowerCase().includes(searchName.value.toLowerCase());
      const uidMatch = String(student.uid).includes(searchName.value);
      return nameMatch || uidMatch;
    });
  }
  // 按科目筛选
  if (selectedSubject.value) {
    result = result.filter(student => {
      const rate = student[selectedSubject.value!];
      return rate !== null && rate !== undefined;
    });
  }
  // 按过线率范围筛选
  if (rateRange.value) {
    const [min, max] = rateRange.value.split('-').map(Number);
    result = result.filter(student => {
      // 如果选择了具体科目，按该科目筛选；否则按任意科目筛选
      if (selectedSubject.value) {
        const rate = student[selectedSubject.value];
        if (rate === null || rate === undefined) return false;
        const ratePercent = rate * 100;
        return ratePercent >= min && ratePercent <= max;
      } else {
        // 检查学生是否有任何科目的过线率在指定范围内
        return availableSubjects.value.some(subject => {
          const rate = student[subject.value];
          if (rate === null || rate === undefined) return false;
          const ratePercent = rate * 100;
          return ratePercent >= min && ratePercent <= max;
        });
      }
    });
  }
  return result;
});
// 排序后的学生列表
const sortedStudentRateList = computed(() => {
  const list = [...filteredStudentRateList.value];
  // 如果选择了科目，按该科目过线率排序
  if (selectedSubject.value) {
    return list.sort((a, b) => {
      const rateA = a[selectedSubject.value] || 0;
      const rateB = b[selectedSubject.value] || 0;
      return sortOrder.value === 'desc' ? rateB - rateA : rateA - rateB;
    });
  }
  // 未选择科目时，按总分过线率排序
  return list.sort((a, b) => {
    const rateA = a['总分'] || 0;
    const rateB = b['总分'] || 0;
    return sortOrder.value === 'desc' ? rateB - rateA : rateA - rateB;
  });
});
// 判断是否为科目列
const isSubjectColumn = (dataIndex: string) => {
  return availableSubjects.value.some(subject => subject.value === dataIndex);
};
// 获取过线率颜色样式类
const getRateClass = (rate: number | null | undefined) => {
  if (rate === null || rate === undefined) return 'normal-rate';
  const ratePercent = rate * 100;
  if (ratePercent >= 50 && ratePercent <= 70) {
    return 'low-rate'; // 50%-70%红色
  } else {
    return 'normal-rate'; // 其他范围默认颜色
  }
};
// 处理搜索
const handleSearch = (value: string) => {
  searchName.value = value;
};
// 处理选择
const handleSelect = (value: string) => {
  // 当选择时，使用学号查找对应的学生姓名
  const student = studentRateList.value.find(s => s.uid === value);
  if (student) {
    searchName.value = student.name;
  }
};
// 处理科目变更
const handleSubjectChange = () => {
  // 科目变更时可以重置排序或其他筛选条件
};
// 应用筛选
const applyFilters = () => {
  // 触发计算属性重新计算，无需额外逻辑
  message.success('筛选条件已应用');
};
// 清除搜索
const clearSearch = () => {
  searchName.value = '';
  selectedSubject.value = '';
  rateRange.value = undefined;
  sortOrder.value = 'desc';
};
// 学号脱敏处理，只显示后四位并在前面加两个星号
const maskStudentId = (studentId: string) => {
  if (!studentId) return '';
  const idStr = String(studentId);
  if (idStr.length <= 4) return idStr;
  return '**' + idStr.slice(-4);
};
const knowledgeLoading = ref(false);
// 查询条件
const knowledgeSubject = ref<string>('');
const knowledgePoint = ref('');
const queryExamN = ref<number>(10);
// 知识点下拉候选选项
const knowledgePointOptions = ref<any[]>([]);
// 汇总返回data
const knowledgeSummary = ref<any>(null);
// 逐场考试列表，给table渲染
const knowledgeExamList = ref<any[]>([]);
// 科目下拉选项
const subjectOptions = ref<string[]>(['语文','数学','英语','物理','化学','生物','历史','政治','地理']);
// 表格列
const knowledgeColumns = ref<any[]>([
  { title: '考试ID', dataIndex: 'exam_id', width: 100, align: 'center' },
  { title: '考试名称', dataIndex: 'exam_name', width: 220, align: 'center' },
  { title: '考试日期', dataIndex: 'exam_date', width: 130, align: 'center' },
  { title: '参与人数', dataIndex: 'participant_count', width: 110, align: 'center' },
  { title: '答对小题数', dataIndex: 'correct_question_count', width: 120, align: 'center' },
  { title: '总小题数', dataIndex: 'total_question_count', width: 110, align: 'center' },
  { title: '本场掌握率', dataIndex: 'mastery_rate', width: 130, align: 'center' },
]);
// 掌握度颜色
const getMasteryClass = (rate: number|null|undefined) => {
  if(rate == null) return 'normal-rate';
  const p = rate * 100;
  if(p < 60) return 'low-rate';
  if(p < 80) return 'mid-rate';
  return 'normal-rate';
};
// 重置知识点筛选
const clearKnowledgeFilter = () => {
  knowledgeSubject.value = '';
  knowledgePoint.value = '';
  queryExamN.value = 10;
  knowledgePointOptions.value = [];
  knowledgeSummary.value = null;
  knowledgeExamList.value = [];
};
// 科目切换，清空候选
const handleKnowledgeSubjectChange = () => {
  knowledgePoint.value = '';
  knowledgePointOptions.value = [];
}
// 拉取知识点候选（非防抖，供输入搜索与自动加载共用）
const fetchKnowledgePointOptions = async (keyword: string, silent = false) => {
  if (!props.classId || !knowledgeSubject.value) {
    knowledgePointOptions.value = [];
    return;
  }
  const trimKeyword = keyword?.trim() ?? '';
  try {
    const res = await getClassKnowledgePointsApi({
      class_id: props.classId,
      subject: knowledgeSubject.value,
      keyword: trimKeyword,
      limit: 100
    }) as any;
    if (res.code === 200 && Array.isArray(res.data)) {
      // 组装AutoComplete选项
      knowledgePointOptions.value = res.data.map(item => ({
        label: item.knowledge_point,
        value: item
      }))
      // total大于返回数量，提示用户
      if (!silent && res.total > res.data.length) {
        message.info('搜索结果较多，请输入更精确关键词');
      }
    } else {
      knowledgePointOptions.value = [];
    }
  } catch (err) {
    console.error('知识点候选搜索失败', err);
    knowledgePointOptions.value = [];
  }
};
// 防抖：知识点输入模糊搜索候选接口（300ms）
const handleKnowledgeSearch = debounce((keyword: string) => {
  fetchKnowledgePointOptions(keyword);
}, 300);
// 用户选中下拉条目，回填完整知识点名称
const handleKnowledgeSelect = (item: any) => {
  knowledgePoint.value = item.knowledge_point;
}
// 查询掌握度数据
const fetchKnowledgeData = async (silent = false) => {
  if (!props.classId) {
    if (!silent) message.warning('请先选择班级');
    return;
  }
  const trimPoint = knowledgePoint.value?.trim() ?? '';
  if (!knowledgeSubject.value || !trimPoint) {
    if (!silent) message.warning('请选择科目并从下拉选择知识点');
    return;
  }
  try {
    knowledgeLoading.value = true;
    const res = (await getClassKnowledgePointMasteryApi({
      class_id: props.classId,
      subject: knowledgeSubject.value,
      knowledge_point: trimPoint,
      n: String(queryExamN.value)
    })) as any;
    if (res?.code === 200 && res.data) {
      const bizData = res.data;
      knowledgeSummary.value = bizData;
      knowledgeExamList.value = bizData.exams ?? [];
      if (knowledgeExamList.value.length === 0) {
        if (!silent) message.info('该知识点暂无有效考试统计数据');
      } else {
        if (!silent) message.success('查询成功');
      }
    } else {
      if (!silent) message.warning(res?.msg || '未获取到知识点数据');
      knowledgeSummary.value = null;
      knowledgeExamList.value = [];
    }
  } catch (err: any) {
    console.error('知识点接口异常', err);
    if (!silent) message.error('请求知识点数据异常');
    knowledgeSummary.value = null;
    knowledgeExamList.value = [];
  } finally {
    knowledgeLoading.value = false;
  }
};
// 进入页面/切换班级时：自动扫描科目，选中第一个有知识点候选的科目并加载其默认知识点
let knowledgeAutoLoading = false;
const autoLoadKnowledgeData = async () => {
  if (!props.classId || knowledgeAutoLoading) return;
  knowledgeAutoLoading = true;
  try {
    for (const subject of subjectOptions.value) {
      knowledgeSubject.value = subject;
      await fetchKnowledgePointOptions('', true);
      const first = knowledgePointOptions.value[0];
      if (first) {
        knowledgePoint.value = first.value?.knowledge_point ?? first.label;
        await fetchKnowledgeData(true);
        return;
      }
    }
    // 所有科目均无知识点候选时保持空状态，由模板空提示兜底
    knowledgeSubject.value = '';
    knowledgePoint.value = '';
    knowledgePointOptions.value = [];
  } finally {
    knowledgeAutoLoading = false;
  }
};
// classId变更清空知识点模块
watch(()=>props.classId, ()=>{
  clearKnowledgeFilter();
})
// 初始化
onMounted(() => {
  fetchSubjectRateData();
  if (props.classId) {
    autoLoadKnowledgeData();
  }
});
// 监听 classId 变化
watch(() => props.classId, () => {
  if (props.classId) {
    fetchSubjectRateData();
    autoLoadKnowledgeData();
  }
});
// 处理数据并更新表格
const processStudentRateData = (classData: any) => {
  const studentOneLineRate = classData.student_one_line_rate || {};
  // 构建学生数据映射表
  const studentMap = new Map<string, any>();
  // 收集所有科目并构建动态列
  const subjectColumns: any[] = [];
  Object.entries(studentOneLineRate).forEach(([subject, students]: [string, any]) => {
    if (Array.isArray(students)) {
      // 添加科目列（支持排序）—— 标题统一转为中文
      const subjectName = subjectMap[subject] || subject;
      subjectColumns.push({
        title: subjectName,
        dataIndex: subject,
        width: 100,
        align: 'center',
      });
      // 将每个学生的该科目过线率添加到学生数据中
      students.forEach((student: any) => {
        if (!studentMap.has(student.uid)) {
          // 姓名优先用接口返回的 name，缺失时从学生列表映射表查找
          const name = student.name || studentNameMap.value.get(String(student.uid)) || '-';
          if (name === '-') {
            console.warn('[学生过线率] 未能解析学生姓名:', student.uid);
          }
          studentMap.set(student.uid, {
            uid: student.uid,
            name: name,
            key: student.uid
          });
        }
        const studentData = studentMap.get(student.uid);
        if (studentData) {
          studentData[subject] = student.rate;
        }
      });
    }
  });
  // 更新表格列（基础列 + 科目列）
  studentRateColumns.value = [
    { title: '学生姓名', dataIndex: 'name', width: 120, fixed: 'left', align: 'center' },
    // { title: '学号', dataIndex: 'uid', width: 120, fixed: 'left', align: 'center', customRender: ({ text }: any) => maskStudentId(text) },
    ...subjectColumns
  ];
  // 更新可用科目列表
  availableSubjects.value = subjectColumns.map(col => ({
    value: col.dataIndex,
    label: col.title
  }));
  // 转换为数组
  studentRateList.value = Array.from(studentMap.values());
};
// 获取学生过线率数据
const fetchSubjectRateData = async (silent = false) => {
  if (!props.classId) return;
  try {
    loading.value = true;
    // 1. 先请求过线率数据，拿到学生 uid 列表
    const res = await postClassAlwaysTopBottomStudents({
      class_ids: [props.classId],
    }, {
      errorHandler: (error: any) => {
        return error;
      },
      getResponse: true,
    });
    const responseData = res.data || res;
    const httpStatus = res.response?.status || res.status;
    let classData: any = null;
    if (httpStatus === 200 && responseData.code === 200 && responseData.data) {
      // 判断 data 是数组还是对象
      if (Array.isArray(responseData.data) && responseData.data.length > 0) {
        classData = responseData.data[0];
      } else if (typeof responseData.data === 'object' && responseData.data.student_one_line_rate) {
        // data 是对象而非数组，直接使用
        classData = responseData.data;
      } else {
        message.info('暂无数据');
        studentRateList.value = [];
        return;
      }
    } else {
      message.warning(responseData.message || '获取数据失败');
      studentRateList.value = [];
      return;
    }
    // 2. 依次补齐姓名（先花名册，再用批量接口补漏），避免与过线率数据并行导致的竞态
    await fetchStudentNames(props.classId);
    await fillMissingStudentNames(classData);
    // 3. 姓名映射就绪后再渲染
    processStudentRateData(classData);
    if (!silent) message.success('数据加载成功');
  } catch (err: any) {
    console.error('请求异常:', err);
    message.error('请求数据失败');
    studentRateList.value = [];
  } finally {
    loading.value = false;
  }
};
// 暴露方法给父组件
__expose({
  refresh: () => {
    fetchSubjectRateData(true);
    // 知识点模块由 autoLoadKnowledgeData 在 classId 变化时自动加载，
    // 此处不再清空，避免父组件查询完成后覆盖已加载的默认数据
  },
});

return (_ctx: any,_cache: any) => {
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_auto_complete = _resolveComponent("a-auto-complete")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input_number = _resolveComponent("a-input-number")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
          _createElementVNode("div", { class: "section-title" }, "学生各科目过线率统计", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_a_card, { class: "rate-card" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_space, {
              wrap: "",
              size: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_auto_complete, {
                  value: searchName.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchName).value = $event)),
                  options: studentNameOptions.value,
                  placeholder: "请输入或选择学生姓名",
                  style: {"width":"250px"},
                  onSearch: handleSearch,
                  onSelect: handleSelect,
                  allowClear: ""
                }, {
                  option: _withCtx(({ value, label }) => [
                    _createElementVNode("div", null, _toDisplayString(label) + " (" + _toDisplayString(maskStudentId(value)) + ")", 1)
                  ]),
                  _: 1
                }, 8, ["value", "options"]),
                _createVNode(_component_a_select, {
                  value: selectedSubject.value,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((selectedSubject).value = $event)),
                  placeholder: "请选择科目",
                  style: {"width":"150px"},
                  allowClear: "",
                  onChange: handleSubjectChange
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "" }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode("全部科目", -1)
                      ]))]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableSubjects.value, (subject) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: subject.value,
                        value: subject.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(subject.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createVNode(_component_a_select, {
                  value: rateRange.value,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((rateRange).value = $event)),
                  placeholder: "过线率范围",
                  style: {"width":"150px"},
                  allowClear: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "0-20" }, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode("0% - 20%", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "20-40" }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode("20% - 40%", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "40-60" }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode("40% - 60%", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "60-80" }, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode("60% - 80%", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "80-100" }, {
                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                        _createTextVNode("80% - 100%", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createVNode(_component_a_select, {
                  value: sortOrder.value,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((sortOrder).value = $event)),
                  placeholder: "排序方式",
                  style: {"width":"150px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "desc" }, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode("降序", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "asc" }, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createTextVNode("升序", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: applyFilters
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("确定筛选", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_a_button, { onClick: clearSearch }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createTextVNode("清除筛选", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_a_table, {
            "data-source": sortedStudentRateList.value,
            bordered: "",
            columns: studentRateColumns.value,
            pagination: { pageSize: 20 },
            scroll: { x: 'max-content', y: 600 },
            loading: loading.value,
            rowKey: "uid"
          }, {
            bodyCell: _withCtx(({ column, record }) => [
              (isSubjectColumn(column.dataIndex))
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(getRateClass(record[column.dataIndex]))
                  }, _toDisplayString(record[column.dataIndex] === null || record[column.dataIndex] === undefined ? '-' : `${Math.round(record[column.dataIndex] * 100)}%`), 3))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["data-source", "columns", "loading"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
          _createElementVNode("div", { class: "section-title" }, "知识点掌握情况", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_a_card, { class: "rate-card" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_space, {
              wrap: "",
              size: 12,
              align: "center"
            }, {
              default: _withCtx(() => [
                _cache[21] || (_cache[21] = _createElementVNode("span", null, "学科：", -1)),
                _createVNode(_component_a_select, {
                  value: knowledgeSubject.value,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((knowledgeSubject).value = $event)),
                  placeholder: "请选择科目",
                  style: {"width":"180px"},
                  allowClear: "",
                  onChange: handleKnowledgeSubjectChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subjectOptions.value, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item,
                        value: item
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createVNode(_component_a_auto_complete, {
                  value: knowledgePoint.value,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((knowledgePoint).value = $event)),
                  options: knowledgePointOptions.value,
                  placeholder: "请输入知识点",
                  style: {"width":"320px"},
                  allowClear: "",
                  onSearch: _unref(handleKnowledgeSearch),
                  onSelect: handleKnowledgeSelect
                }, {
                  option: _withCtx(({ label, value }) => [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", null, _toDisplayString(label), 1),
                      _createElementVNode("div", _hoisted_6, "题目:" + _toDisplayString(value.question_count) + " | 考试:" + _toDisplayString(value.exam_count), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["value", "options", "onSearch"]),
                _cache[22] || (_cache[22] = _createElementVNode("span", null, "考试次数：", -1)),
                _createVNode(_component_a_input_number, {
                  value: queryExamN.value,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((queryExamN).value = $event)),
                  placeholder: "查询考试场数",
                  min: 1,
                  max: 100,
                  style: {"width":"140px"}
                }, null, 8, ["value"]),
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: fetchKnowledgeData,
                  loading: knowledgeLoading.value
                }, {
                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                    _createTextVNode("查询", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_a_button, { onClick: clearKnowledgeFilter }, {
                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                    _createTextVNode("重置", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          (knowledgeSummary.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "summary-label" }, "知识点", -1)),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(knowledgePoint.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "summary-label" }, "班级人数", -1)),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(knowledgeSummary.value.active_student_count ?? 0), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "summary-label" }, "有效考试场数", -1)),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(knowledgeSummary.value.actual_exam_count) + " / " + _toDisplayString(knowledgeSummary.value.requested_exam_count), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "summary-label" }, "总答对小题", -1)),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(knowledgeSummary.value.correct_question_count), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "summary-label" }, "总有效小题", -1)),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(knowledgeSummary.value.total_question_count), 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "summary-label" }, "整体掌握率", -1)),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("b", {
                        class: _normalizeClass(getMasteryClass(knowledgeSummary.value?.mastery_rate))
                      }, _toDisplayString(knowledgeSummary.value?.mastery_rate != null
                    ? `${(knowledgeSummary.value.mastery_rate * 100).toFixed(0)}%`
                    : '暂无统计'), 3)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_a_table, {
            "data-source": knowledgeExamList.value,
            bordered: "",
            columns: knowledgeColumns.value,
            pagination: { pageSize: 20 },
            scroll: { x: 'max-content', y: 460 },
            loading: knowledgeLoading.value,
            rowKey: "exam_id"
          }, {
            bodyCell: _withCtx(({ column, record }) => [
              (column.dataIndex === 'mastery_rate')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(getMasteryClass(record.mastery_rate))
                  }, _toDisplayString(record.mastery_rate === null ? '-' : `${Math.round(record.mastery_rate * 100)}%`), 3))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["data-source", "columns", "loading"]),
          (!knowledgeLoading.value && knowledgeExamList.value.length === 0 && knowledgeSummary.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, " 暂无可统计的有效考试数据 "))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})